module.exports = __webpack_public_path__ + "static/media/skpic_RazitkoPLKulate.e8318f2f.png";